import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import PropTypes from "prop-types";

const CustomDialog = (props) => {
    const {
      open,
      onClose,
      heading,
      text,
      button1Text,
      button2Text,
      onButton1Click,
      onButton2Click,
    } = props;
  
    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{heading}</DialogTitle>
              <DialogContent>
                  <DialogContentText >
                  {text}
                  </DialogContentText>
              </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            onClose();
            onButton1Click();
          }} autoFocus>
            {button1Text}
          </Button>
          <Button onClick={() => {
            onClose();
            onButton2Click();
          }}>
            {button2Text}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  CustomDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  button1Text: PropTypes.string.isRequired,
  button2Text: PropTypes.string.isRequired,
  onButton1Click: PropTypes.func.isRequired,
  onButton2Click: PropTypes.func.isRequired,
};
  export default CustomDialog;